import SessionService from "../../../../../../services/session/SessionService";
import { Weather } from "../weather/Weather";
import { Clock } from "../clock/Clock";
import { NavigateItem, NavigateItems, NavigatorCenter, NavigatorLeft, NavigatorRight, NavigatorWrapper, ScreenTitle, ScreenTitleCn,  NavigateItemSeparator } from "./Navigator.styled";

interface NavigatorProps {
    selected?: string
}

let Navigator: React.FC<NavigatorProps> = (props)=> {
    let title = {
        cn: "牵引车智能互联系统"
    };

    return (
        <NavigatorWrapper>
            <NavigatorLeft>
                <NavigateItems>
                    <NavigateItem href={SessionService.getInstance().getCurrentUserProfile().admin ? "/#/" : '#'}>管理控制台</NavigateItem>
                    <NavigateItemSeparator />
                    <NavigateItem href="/#/big-screen/overview" className={props.selected=='OVERVIEW' ? "selected" : "" }>系统总览</NavigateItem>
                    <NavigateItemSeparator />
                    <NavigateItem className={props.selected=='DEVICE_DETAILS' ? "selected" : "" }>设备详情</NavigateItem>
                </NavigateItems>
            </NavigatorLeft>

            <NavigatorCenter>
                <ScreenTitle>
                    <ScreenTitleCn>{title.cn}</ScreenTitleCn>
                </ScreenTitle>
            </NavigatorCenter>

            <NavigatorRight>
                <Weather />
                <Clock />
            </NavigatorRight>
        </NavigatorWrapper>
    )
};

export default Navigator;
